import React, { useEffect } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  ImageField,
  NumberInput,
  DateInput,
  useNotify,
  useRedirect,
  useCreate,
  Toolbar,
  SaveButton,
  required
} from 'react-admin';
import DynamicZoneInput from '../../../components/admin/DynamicZoneInput/DynamicZoneInput';

function ArticuloCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSubmit = (data: any) => {
    create(
      'articulos',
      { data },
      {
        onSuccess: () => {
          notify('Elemento creado');
          redirect('list', 'articulos');
        },
        onError: (error: any) => {
          notify(`Error: ${error.message}`, { type: 'error' });
        },
      }
    );
  };

  useEffect(() => {
    document.title = 'Crear Artículo';
  }, []);

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput source="titulo" validate={[required()]} />
        <FileInput
          source='imagen_cubierta'
          label='Imagen de Cubierta'
          validate={[required()]}
        >
          <ImageField source="src" />
        </FileInput>
        <TextInput multiline source="descripcion"  validate={[required()]} />
        <NumberInput source="minutos_lectura" validate={[required()]} />
        <DateInput source="fecha" validate={[required()]} />
        <TextInput source="autor" validate={[required()]} />
        <TextInput source="categoria" validate={[required()]} />
        <TextInput source="etiqueta" validate={[required()]} />
        <TextInput source="slug" validate={[required()]} />
        <DynamicZoneInput source="contenido"  />
      </SimpleForm>
    </Create>
  )
}

export default ArticuloCreate;